import { LazyAction, LazyModule } from 'owa-bundling';
import type * as lazyIndex from './lazyIndex';

/**
 * Splits the heavy selection-handling graph (bizchat context, user-highlighting, forced-layout
 * measurement) out of the boot bundle. The reading-pane selection hook loads it on demand the
 * first time the user actually selects text, rather than eagerly at app boot.
 */
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "ReadingPaneSelectionHandler"*/ './lazyIndex'),
    { name: 'ReadingPaneSelectionHandler' }
);

export const lazyHandleSelection: LazyAction<typeof lazyIndex.handleSelection, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.handleSelection);
